import * as React from 'react';
import { useSelector } from 'react-redux';

import { openUserCard } from '../../../../actions/userCard/openUserCard';
import { ChatCompanionTitle } from '../../../../components/ChatCompanionTitle';
import { currentOpenChatIDSelector } from '../../../../selectors';
import { useAppDispatch } from '../../../../types/redux/state';
import { TFormattedCompanionData } from '../../../../utils/formatCompanionData';

interface ICompanionTitleContainerProps {
  companion: TFormattedCompanionData;
}

export const CompanionTitleContainer = ({
  companion: { companionName, accountTypeName, companionIdStr, companionId },
}: ICompanionTitleContainerProps) => {
  const dispatch = useAppDispatch();

  const chatId = useSelector(currentOpenChatIDSelector);

  const handleClickName = React.useCallback(() => {
    if (chatId && companionId) {
      dispatch(openUserCard(companionId));
    }
  }, [chatId, companionId, dispatch]);

  const secondaryText = React.useMemo(
    () => (!companionName && companionIdStr ? `(${companionIdStr})` : undefined),
    [companionName, companionIdStr],
  );

  return (
    <ChatCompanionTitle
      dataTestId="chat_header_title"
      primaryText={companionName || accountTypeName}
      secondaryText={secondaryText}
      handleClickName={handleClickName}
    />
  );
};
